var _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPptpttx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 1,
    fill: "#EDF2F8",
    width: 46,
    height: 62
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 31,
    cy: 44,
    r: 11
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D4DFEB",
    d: "M31,33v10l8.254,8.254C40.958,49.316,42,46.783,42,44C42,37.925,37.075,33,31,33z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10_copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C2CDDC",
    d: "M20,43.85c0,2.744,1.042,5.244,2.746,7.154L31,42.863V33C24.925,33,20,37.857,20,43.85z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_7_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8592A5",
    d: "M31,56c6.627,0,12-5.373,12-12s-5.373-12-12-12s-12,5.373-12,12S24.373,56,31,56z M32,34.051 c5.053,0.502,9,4.764,9,9.949c0,2.152-0.688,4.141-1.843,5.771L32,42.614V34.051z M37.869,51.255C36.077,52.952,33.663,54,31,54 s-5.077-1.048-6.869-2.745L31,44.386L37.869,51.255z M30,34.051v8.563l-7.157,7.157C21.687,48.141,21,46.152,21,44 C21,38.814,24.947,34.553,30,34.051z M56,8h-2V2c0-1.104-0.896-2-2-2H8C6.896,0,6,0.896,6,2v60c0,1.104,0.896,2,2,2h44 c1.104,0,2-0.896,2-2V26h2c1.104,0,2-0.896,2-2V10C58,8.896,57.104,8,56,8z M52,8H28c-1.104,0-2,0.896-2,2v14c0,1.104,0.896,2,2,2 h24v36H8V2h44V8z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.582,18.065V20.5h-1.689v-7.285h2.569c0.513,0,0.954,0.061,1.323,0.183 c0.367,0.122,0.671,0.289,0.909,0.503c0.238,0.213,0.414,0.465,0.528,0.755c0.113,0.29,0.17,0.604,0.17,0.939 c0,0.363-0.059,0.697-0.176,1c-0.117,0.304-0.295,0.563-0.535,0.78s-0.544,0.386-0.912,0.508c-0.368,0.121-0.805,0.183-1.308,0.183 H34.582z M34.582,16.79h0.88c0.44,0,0.757-0.105,0.95-0.315s0.29-0.503,0.29-0.88c0-0.166-0.025-0.318-0.075-0.455 s-0.126-0.254-0.228-0.353c-0.102-0.098-0.229-0.174-0.385-0.228c-0.155-0.053-0.339-0.079-0.553-0.079h-0.88V16.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M40.962,18.065V20.5h-1.69v-7.285h2.57c0.514,0,0.954,0.061,1.322,0.183 c0.369,0.122,0.672,0.289,0.91,0.503c0.238,0.213,0.414,0.465,0.527,0.755s0.17,0.604,0.17,0.939c0,0.363-0.059,0.697-0.175,1 c-0.116,0.304-0.295,0.563-0.534,0.78c-0.24,0.217-0.545,0.386-0.913,0.508c-0.368,0.121-0.804,0.183-1.308,0.183H40.962z  M40.962,16.79h0.88c0.439,0,0.757-0.105,0.95-0.315s0.29-0.503,0.29-0.88c0-0.166-0.025-0.318-0.075-0.455 s-0.126-0.254-0.228-0.353c-0.102-0.098-0.23-0.174-0.385-0.228c-0.155-0.053-0.34-0.079-0.553-0.079h-0.88V16.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50.941,13.215v1.34h-2.05V20.5h-1.69v-5.945h-2.049v-1.34H50.941z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptpttx);
export default __webpack_public_path__ + "static/media/_ppt pttx.bd3de14c4b67a77f40b93fea7a0fcd85.svg";
export { ForwardRef as ReactComponent };